import { render, staticRenderFns } from "./FullscreenModal.vue?vue&type=template&id=4b8f8a63"
import script from "./FullscreenModal.vue?vue&type=script&lang=ts"
export * from "./FullscreenModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports